<template>
  <GestionBloqueos />
</template>
<script>
import GestionBloqueos from "./components/GestionBloqueos";
export default {
  components: { GestionBloqueos },
};
</script>